// extracted by mini-css-extract-plugin
export default {"text":"scan_text__ecJa+","bar":"scan_bar__YhjXk","completed":"scan_completed__D69pC","progress":"scan_progress__Lnu0q","moving-gradient":"scan_moving-gradient__N8w1Z"};